import { ICapabilities } from 'library/ts/interfaces/utilities/capabilities/ICapabilities';
import { IProjectInfo } from 'library/ts/IProjectInfo';
import { ProjectInfo } from 'library/ts/ProjectInfo';
import { Capabilities } from 'library/ts/utilities/Capabilities';
import { declareNamespace } from 'library/ts/utilities/modules/DOM';
import { Utilities } from 'library/ts/utilities/Utilities';

/**
 * @description Player Services namespaces
 */
declare global {
	interface Window {
		PARA: IPARA;
		PlayerServicesProjectInfo: IProjectInfo;
	}
}

/**
 * @description Interface for PARA namespace
 */
export interface IPARA {
	PlayerServices: {
		Utilities?: Utilities;
		Capabilities?: ICapabilities;
		// application start time
		StartTime?: number;
	}
}

// store project info data at the top
window.PlayerServicesProjectInfo = ProjectInfo as IProjectInfo;

/**
 * @description Initializes PARA.PlayerServices shared namespace
 * @return {Promise<IPARA>}
 */
export const setupPlayerServicesNamespace = (): Promise<IPARA> => {
	return new Promise(
		( resolve, reject ) => {
			const rootNamespace: any | IPARA = 'PARA.PlayerServices';
			const utils = Utilities.getInstance();

			/**
			 * @description Initialize Capabilities class
			 */
			const initializeCapabilities = (): void => {
				if ( utils.Type.isEmpty( ( window?.PARA?.PlayerServices?.Capabilities ) ) ) {
					// start capabilities detection
					new Capabilities( utils ).detect().then(
						( data ) => {
							onCapabilitiesReady( data.result as ICapabilities );
						}
					);
				} else {
					onCapabilitiesReady( window?.PARA?.PlayerServices?.Capabilities );
				}
			};

			/**
			 * @description Capabilities ready callback
			 * @param {ICapabilities} capabilities
			 */
			const onCapabilitiesReady = ( capabilities: ICapabilities ) => {
				// store capabilities detection result
				window.PARA.PlayerServices.Capabilities = capabilities;
				// resolve promise
				resolve( window.PARA );
			};

			// initialize Root namespace
			if ( utils.Type.isEmpty( utils.Object.getDeepVal( window, rootNamespace ) ) ) {
				// declare initial namespace
				declareNamespace( rootNamespace );
			}

			// initialize Session start time
			if ( !utils.Type.isNumber( ( window?.PARA?.PlayerServices?.StartTime ) ) ) {
				window.PARA.PlayerServices.StartTime = new Date().getTime();
			}

			// store Utilities reference in namespace
			if ( utils.Type.isEmpty( ( window?.PARA?.PlayerServices?.Utilities ) ) ) {
				// store utils Utilities
				window.PARA.PlayerServices.Utilities = utils;
			}

			// initialize capabilities
			initializeCapabilities();
		}
	);

};